import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';

export const interviewInterestApi = createApi({
  reducerPath: 'interviewInterestApi',
  baseQuery: fetchBaseQuery({
    baseUrl: cmsApiConfig.url + '/portalapi',
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['ParticipantDetails'],
  endpoints: (builder) => ({
    postInterviewInterestAnswer: builder.mutation<
      void,
      { participantId: string; answer: number }
    >({
      query: ({ participantId, answer }) => ({
        url: `/interviewInterestAnswer?participantId=${participantId}&answer=${answer}`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, { participantId }) => {
        return [{ type: 'ParticipantDetails', id: participantId }];
      },
    }),
  }),
});

export const { usePostInterviewInterestAnswerMutation } = interviewInterestApi;
